import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(theme => ({
  gridPaper: {
    maxHeight: 400,
    overflowY: 'auto',
    minHeight: 144,
  },
}));
